import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { DialogContainer, DialogActions, DialogContent, DialogTitle, DialogCloseButton } from '@shared/ui/Dialog';
import { useTranslation } from 'react-i18next';
import { Button } from '@shared/ui/Button';
import { CircularLoader } from '@shared/ui/Loader';
import { ToastService } from '@shared/lib/services/toast.service';
import styles from './DeleteUserDialog.module.scss';
import { useRemoveUser } from '../../lib/hooks';
import { HelperText } from '@shared/ui/HelperText';
export function DeleteUserDialog({ user, onSuccess, onClose }) {
    const { t } = useTranslation();
    const { removeUser, isRemoved, isRemoving } = useRemoveUser();
    const handleDelete = () => {
        removeUser(user.id);
    };
    useEffect(() => {
        if (isRemoved) {
            ToastService.success(t('User was successfully deleted.'));
            onClose();
            onSuccess();
        }
    }, [isRemoved, onClose, t, onSuccess]);
    return (_jsxs(DialogContainer, { fullWidth: true, open: true, children: [_jsxs(DialogTitle, { variant: "h5", children: [t('Delete User'), _jsx(DialogCloseButton, { onClick: onClose })] }), _jsxs(DialogContent, { className: styles.content, children: [_jsx("div", { children: t('Are you sure want to delete User?') }), _jsx("div", { className: styles.email, children: user.email }), _jsx(HelperText, { variant: "outlined", children: t('After this action, User will not be able to login into current project, that will not affect access to any other projects.') })] }), _jsxs(DialogActions, { className: styles.actions, children: [_jsx(Button, { onClick: onClose, variant: "outlined", className: styles.button, children: t('Cancel') }), _jsx(Button, { onClick: handleDelete, variant: "contained", className: styles.button, disabled: isRemoving, endIcon: isRemoving ? _jsx(CircularLoader, { size: "1em", color: "inherit" }) : undefined, children: t('Delete') })] })] }));
}
